"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Tag(_a) {
    var tag = _a.tag, index = _a.index, tags = _a.tags, setTags = _a.setTags;
    var _b = ra_fetch_1.useApi('backend')
        .records(setTags, tags)
        .delete('tags', {
        id: tag.id,
    }), deleteTag = _b[0], submitDeleteTag = _b[1];
    return react_1.default.createElement("span", { className: 'relative inline-block mr-2 mb-2 py-2 pl-4 pr-8 bg-secondary rounded-sm', key: index },
        tag.channel.label,
        react_1.default.createElement(storybook_1.Buttons.Button, { className: 'absolute right-2 top-3 cursor-pointer', onClick: submitDeleteTag },
            react_1.default.createElement(storybook_1.Icons.Icon, { className: 'w-4', name: 'x' })));
}
exports.default = Tag;
